(function () {
  class BigWin extends PIXI.Container {
    constructor(numStages, thresholds, timePerStage) {
      super();

      this._numStages = numStages;
      this._thresholds = thresholds;

      this._timePerStage = timePerStage;

      this._nextState = "IDLE";
      this._introTimer = undefined;
      this._currentStage = 0;
      this._localStage = 0;
      this._countTimer = undefined;
      this._outroTimer = undefined;
      this._winAmount = 0;
      this._animating = false;
      this._skippedBeforeTriggered = false;
      this._newSpin = false;

      this._awardGrowAnim = undefined;

      this._allowOrientationChange = false;

      this._particleEmitEndTime = 1500;
      this._endTimerDelayTime = 2000;
      this._endTimerTime = 750;

      this._isBigWin = false;

      this._useAlternateStartPos = false;

      messageBus.subscribe(
        "spinner:GameConfigEvent",
        this.onGameConfigEvent.bind(this)
      );
      messageBus.subscribe(
        "stake:stakeChanged",
        this.onStakeChanged.bind(this)
      );
      messageBus.subscribe("spinner:SpinEvent", this.onSpin.bind(this));

      const self = this;
      StateMachine.Create(this);
      Reflex.addToUpdate(function (delta) {
        self.update(delta);
      });

      this.stateMachine.addState("IDLE", function () {});

      this.stateMachine.addState("INTRO", function () {
        if (self.phase.enter()) {
          self._awardValue.visible = true;
          self._awardValue.alpha = 0;
          self._bigWinAwardValueParent.scale.x = 5;
          self._bigWinAwardValueParent.scale.y = 5;
        }

        if (self.phase.timed(750)) {
          const progress = self.phase.Progress;
          self._bigWinAwardValueParent.scale.x = 1 + 4 * (1 - progress);
          self._bigWinAwardValueParent.scale.y = 1 + 4 * (1 - progress);
          self._awardValue.alpha = progress;
        }

        if (self.phase.once()) {
          if (gameController.inFreeSpins) {
            gameController.winningsContainer.visible = false;
          } else {
            gameController.winningsContainer.visible = true;
          }

          self._bigWinAwardValueParent.scale.x = 1;
          self._bigWinAwardValueParent.scale.y = 1;
          self._awardValue.alpha = 1;

          self.stateMachine.switchState(self._nextState);
        }

        if (self.phase.exit()) {
          self._bigWinAwardValueParent.scale.x = 1;
          self._bigWinAwardValueParent.scale.y = 1;
          self._awardValue.alpha = 1;
        }
      });

      this.stateMachine.addState("ANIMATE_BIG_WIN_START", function () {
        if (self.phase.enter()) {
          self.prepBgAnim();
        }

        if (self.phase.timed(1250)) {
          let start = 0;
          let startX = 0;
          if (self._useAlternateStartPos) {
            startX = self._awardValueStartPosFeatures.position.getX();
            start = self._awardValueStartPosFeatures.position.getY();
          } else {
            startX = self._awardValueStartPos.position.getX();
            start = self._awardValueStartPos.position.getY();
          }
          const end = self._awardValueEndPos.position.getY();
          const dist = end - start;
          const endX = self._awardValueEndPos.position.getX();
          const distX = endX - startX;
          const x = startX + distX * self.phase.Progress;
          const y = start + dist * self.phase.Progress;
          self._bigWinAwardValueParent.position.setX(x);
          self._bigWinAwardValueParent.position.setY(y);
        }

        if (self.phase.once()) {
          self._bigWinAwardValueParent.position.setX(
            self._awardValueEndPos.position.getX()
          );
          self._bigWinAwardValueParent.position.setY(
            self._awardValueEndPos.position.getY()
          );
          self.stateMachine.switchState("IDLE");
        }

        if (self.phase.exit()) {
          self._bigWinAwardValueParent.position.setX(
            self._awardValueEndPos.position.getX()
          );
          self._bigWinAwardValueParent.position.setY(
            self._awardValueEndPos.position.getY()
          );
          timerManager.stop(self._introTimer);
        }
      });

      this.stateMachine.addState("ANIMATE_BIG_WIN_PANEL", function () {
        if (self.phase.once()) {
          self._localStage = self._currentStage;
          ++self._currentStage;
          self._stageContainers.forEach(function (container) {
            container.visible = false;
          });
          self._stageContainers[self._localStage].visible = true;
          self._stageContainers[self._localStage].alpha = 0;
          self._stageContainers[self._localStage].scale.x = 4;
          self._stageContainers[self._localStage].scale.y = 4;

          self._particles.particleEmitter.emit = true;
          self._particles.visible = true;
        }

        if (self.phase.timed(750)) {
          self._stageContainers[self._localStage].alpha = self.phase.Progress;
          self._stageContainers[self._localStage].scale.x =
            1 + 4 * (1 - self.phase.Progress);
          self._stageContainers[self._localStage].scale.y =
            1 + 4 * (1 - self.phase.Progress);
        }

        if (self.phase.exit()) {
          self._stageContainers[self._localStage].alpha = 1;
          self._stageContainers[self._localStage].scale.x = 1;
          self._stageContainers[self._localStage].scale.y = 1;
        }
      });

      this.stateMachine.addState("ANIMATE_BIG_WIN_RESET_PANEL", function () {
        if (self.phase.once()) {
          self.stateMachine.switchState("ANIMATE_BIG_WIN_PANEL");
        }
      });

      this.stateMachine.addState("BACK_TO_MAIN_GAME", function () {
        if (self.phase.enter()) {
          self._animating = false;
          self.backToMainGame();
        }
      });

      this.stateMachine.addState(
        "BACK_TO_MAIN_GAME_FROM_SMALL_WIN",
        function () {
          if (self.phase.enter()) {
            self._animating = false;
            self.backToMainGameFromSmallerWin(false);
          }
          if (self.phase.timed(1000)) {
          }
          if (self.phase.once()) {
            self._awardValue.visible = false;
          }
        }
      );
    }

    isCurrentlyPlaying() {
      return this._isBigWin;
    }

    update(delta) {
      if (this.stateMachine) {
        this.stateMachine.update();
      }
      if (this._animating) {
        const rotThisSpin = delta / 1000;
        this._ray.rotation = (this._ray.rotation + rotThisSpin) % (Math.PI * 2);
      }
    }

    onGameConfigEvent() {
      this._stageContainers = [];
      for (let i = 0; i < this._numStages; ++i) {
        this._stageContainers[i] = resourceManager.get(
          "bigWin:stage" + i + "Container"
        );
        this._stageContainers[i].visible = false;
      }

      this._mainPanel = resourceManager.get("bigWin:moneyPanel");
      this._mainPanel.visible = false;

      this._bigWinContainer = resourceManager.getContainer("bigWinContainer");
      this._bigWinContainer.visible = false;

      this._awardValueContainer = resourceManager.getContainer(
        "awardValueContainer"
      );
      this._awardValueContainer.visible = false;
      this._bigWinAwardValueParent = resourceManager.get(
        "bigWinAwardValueContainer"
      );
      this._awardValue = resourceManager.get(
        "bigWinAwardValueContainer:bigWinAwardValue"
      );
      this._awardValueShine = resourceManager.get(
        "bigWinAwardValueContainer:bigWinAwardValueShine"
      );

      this._awardValueShine.visible = false;
      this._awardValueShine.alpha = 0;

      this._awardValueStartPos = resourceManager.get(
        "bigWinAwardValueStartPos"
      );
      this._awardValueStartPosFeatures = resourceManager.get(
        "bigWinAwardValueStartPosFeatures"
      );
      this._awardValueEndPos = resourceManager.get("bigWinAwardValueEndPos");

      this._screenDim = resourceManager.get("screenDim");
      this._screenDim.beginFill(0x000000);
      this._screenDim.lineStyle(0, 0x000000);
      this._screenDim.drawRect(0, 0, 1280, 1280);
      this._screenDim.visible = false;
      this._screenDim.alpha = 0;

      this._ray = resourceManager.get("bigWinRay");
      this._ray.visible = false;

      this._rayAnim = gsap.to(this._ray, {
        paused: true,
        duration: 10,
        rotation: Math.PI * 2,
        repeat: -1,
        ease: "none",
      });

      this._particles = particleManager.createEmitter(
        "bigwin_emitter",
        "bigWinParticlesContainer",
        0,
        0,
        false
      );
      this._particles.visible = false;
      this._particles.particleEmitter.emit = false;

      this._cappedWinPopup = resourceManager.get(
        "featurePopupContainer:cappedWinPopup"
      );
      this._cappedWinPopup.visible = false;
      this._cappedWinPopupButton = resourceManager.get(
        "featurePopupContainer:cappedWinPopup:pressStartColourBox"
      );
      this._cappedWinPopupButton.interactive = false;
      this._popupMaskDimObject = resourceManager.get("popupMaskDimObject");

      this._skipBigWinBox = resourceManager.get("bigWin:skipBigWinBox");
      this._skipBigWinBox.interactive = false;
      this._skipBigWinBox.visible = false;
      this._skipBigWinBox.mousedown = this._skipBigWinBox.touchstart =
        this.skip.bind(this);
    }

    onStakeChanged(stake) {
      this._stake = resourceManager
        .getController("stakeController")
        .getBaseStake();
    }

    checkBigWin(winAmount) {
      return winAmount >= this._thresholds[0] * this._stake;
    }

    start(
      winAmount,
      callback,
      bigWinOrNothing,
      smallWinOnly,
      screenObscuredCallback,
      useAlternateStartPos,
      capped,
      smallestWinOnly
    ) {
      this._screenDim.visible = true;
      this._screenDim.alpha = 0;

      gsap.to(this._screenDim, {
        duration: 1,
        alpha: 0.6,
      });

      if (capped) {
        this._cappedWinPopup.visible = true;
        this._cappedWinPopup.alpha = 0;
        const self = this;
        timerManager.addTimer(
          500,
          function (progress) {
            self._popupMaskDimObject.show(true, progress);
            self._cappedWinPopup.alpha = progress;
          },
          function () {
            self._popupMaskDimObject.show(true, 1);
            self._cappedWinPopup.alpha = 1;

            self._cappedWinPopupButton.interactive = true;
            self._cappedWinPopupButton.touchend =
              self._cappedWinPopupButton.mouseup = function () {
                self._cappedWinPopup.visible = false;
                self._popupMaskDimObject.show(false);
                self._cappedWinPopupButton.interactive = false;
                self._cappedWinPopupButton.touchend =
                  self._cappedWinPopupButton.mouseup = function () {};
                self.startBigWin(
                  winAmount,
                  callback,
                  bigWinOrNothing,
                  smallWinOnly,
                  screenObscuredCallback,
                  useAlternateStartPos,
                  smallestWinOnly
                );
              };
          }
        );
      } else {
        this.startBigWin(
          winAmount,
          callback,
          bigWinOrNothing,
          smallWinOnly,
          screenObscuredCallback,
          useAlternateStartPos,
          smallestWinOnly
        );
      }
    }

    startBigWin(
      winAmount,
      callback,
      bigWinOrNothing,
      smallWinOnly,
      screenObscuredCallback,
      useAlternateStartPos,
      smallestWinOnly
    ) {
      //bit of a hack to stop big win thinking it needs to show a win on initNewSpin
      if (this._newSpin) {
        return;
      }

      if (useAlternateStartPos === undefined) {
        useAlternateStartPos = false;
      }

      this._useAlternateStartPos = useAlternateStartPos;

      if (bigWinOrNothing === undefined) {
        bigWinOrNothing = false;
      }
      if (smallWinOnly === undefined) {
        smallWinOnly = false;
      }
      this._isBigWin = false;

      this._rayAnim.play();

      this._ray.alpha = 0;
      this._ray.visible = true;

      gsap.to(this._ray, {
        duration: 0.5,
        alpha: 1,
      });

      this._screenObscuredCallbackInvoked = false;
      this._animating = true;
      this._callback = callback;
      this._screenObscuredCallback = screenObscuredCallback;
      this._winAmount = winAmount;
      this._awardValue.visible = false;
      this._awardValueContainer.visible = true;

      this._allowOrientationChange = true;

      if (this._skippedBeforeTriggered) {
        this._particleEmitEndTime = 0;
        this._endTimerDelayTime = 100;
        this._endTimerTime = 250;
        this._skippedBeforeTriggered = false;
        this.doSmallestWin(true);
      } else {
        this._skippedBeforeTriggered = false;
        if (
          winAmount >= this._thresholds[0] * this._stake &&
          !smallWinOnly &&
          !smallestWinOnly
        ) {
          this._particleEmitEndTime = 1500;
          this._endTimerDelayTime = 2000;
          this._endTimerTime = 750;

          this.doBigWin();
        } else if (winAmount > this._stake && !smallestWinOnly) {
          if (!bigWinOrNothing) {
            this._particleEmitEndTime = 250;
            this._endTimerDelayTime = 750;
            this._endTimerTime = 750;
            this.doSmallWin();
          } else {
            this._animating = false;
            this._allowOrientationChange = false;
            callback();
          }
        } else if (winAmount <= this._stake || smallestWinOnly) {
          if (!bigWinOrNothing) {
            this._particleEmitEndTime = 250;
            this._endTimerDelayTime = 750;
            this._endTimerTime = 750;
            this.doSmallestWin();
          } else {
            this._animating = false;
            this._allowOrientationChange = false;
            callback();
          }
        }
      }
    }

    doSmallestWin() {
      if (this._useAlternateStartPos) {
        this._bigWinAwardValueParent.position.set(
          this._awardValueStartPosFeatures.position.getX(),
          this._awardValueStartPosFeatures.position.getY()
        );
      } else {
        this._bigWinAwardValueParent.position.set(
          this._awardValueStartPosFeatures.position.getX(),
          this._awardValueStartPosFeatures.position.getY()
        );
      }
      this._awardValue.setText(this.formatText(this._winAmount));
      this._awardValue.visible = true;
      gameController.winningsContainer.visible = true;

      this.stateMachine.switchState("BACK_TO_MAIN_GAME_FROM_SMALL_WIN");
      const self = this;
      timerManager.addTimeout(500, function () {
        this._allowOrientationChange = false;
        self._callback();
      });
    }

    doSmallWin() {
      this._bigWinAwardValueParent.position.set(
        this._awardValueStartPosFeatures.position.getX(),
        this._awardValueStartPosFeatures.position.getY()
      );

      this._awardValue.setText(this.formatText(this._winAmount));
      this._nextState = "BACK_TO_MAIN_GAME_FROM_SMALL_WIN";
      this.stateMachine.switchState("INTRO");

      const self = this;
      timerManager.addTimeout(500, function () {
        this._allowOrientationChange = false;
        self._callback();
      });
    }

    hideText() {
      this._awardValue.visible = false;
    }

    formatText(amount) {
      return gdk.formatCurrency(amount);
    }

    doBigWin() {
      resourceManager.getContainer("bigWinBgContainerLandscape").visible = true;
      this._isBigWin = true;

      gameData.musicManager.fadeOutAllMusic(0.3);
      gameData.musicManager.startBigWin();

      this._nextState = "ANIMATE_BIG_WIN_START";
      this.stateMachine.switchState("INTRO");

      this._currentStage = 0;
      this.initialCountup();

      if (this._useAlternateStartPos) {
        this._bigWinAwardValueParent.position.set(
          this._awardValueStartPosFeatures.position.getX(),
          this._awardValueStartPosFeatures.position.getY()
        );
      } else {
        this._bigWinAwardValueParent.position.set(
          this._awardValueStartPos.position.getX(),
          this._awardValueStartPos.position.getY()
        );
      }
    }

    initialCountup() {
      const self = this;

      game.thunderAnim.play(0);
      soundManager.play("thunder");

      gameData.musicManager.startPotBonusCountUp();

      const initialValue = this._thresholds[0] * this._stake * 1;

      this._countTimer = timerManager.addTimer(
        2100,
        function (progress) {
          const curVal = initialValue * progress;
          self._awardValue.setText(self.formatText(curVal));
        },
        function () {
          self._awardValue.setText(self.formatText(initialValue));

          let nextThreshold = self.calculateNextThreshold(self._winAmount);

          let amountToCount = self.calculateAmountToCount(
            initialValue,
            nextThreshold,
            self._winAmount
          );

          self.countupTotal(initialValue, amountToCount);
        }
      );
    }

    countupTotal(initialValue, amountToCount) {
      this.stateMachine.switchState("ANIMATE_BIG_WIN_PANEL");
      const self = this;

      this._skipBigWinBox.interactive = true;
      this._skipBigWinBox.visible = true;

      let range = 0;
      if (this._currentStage === this._thresholds.length - 1) {
        range = this._stake * 1000;
      } else {
        range =
          (this._thresholds[this._currentStage + 1] -
            this._thresholds[this._currentStage]) *
          this._stake;
      }
      const pct = amountToCount / range;
      const time = this._timePerStage * pct;

      this._awardGrowAnim = gsap.to(self._bigWinAwardValueParent, {
        duration: 1,
        pixi: { scaleX: 1.1, scaleY: 1.1 },
        repeat: 1,
        yoyo: true,
      });

      this._countTimer = timerManager.addTimer(
        time,
        function (progress) {
          const curVal = initialValue + amountToCount * progress;
          self._awardValue.setText(self.formatText(curVal));
        },
        function () {
          const newValue = initialValue + amountToCount;
          self._awardValue.setText(self.formatText(newValue));

          if (newValue < self._winAmount) {
            let nextThreshold = self.calculateNextThreshold(self._winAmount);
            let amountToCount = self.calculateAmountToCount(
              newValue,
              nextThreshold,
              self._winAmount
            );
            self.countupTotal(newValue, amountToCount);
          } else {
            self.outro();
          }
        }
      );
    }

    calculateNextThreshold(fullAmount) {
      game.thunderAnim.play(0);

      if (this._currentStage === this._thresholds.length - 1) {
        return fullAmount;
      } else {
        return this._thresholds[this._currentStage + 1] * this._stake;
      }
    }

    calculateAmountToCount(initialValue, newThreshold, fullAmount) {
      if (fullAmount <= newThreshold) {
        return fullAmount - initialValue;
      } else {
        return newThreshold - initialValue;
      }
    }

    prepBgAnim() {
      this._bigWinContainer.alpha = 0;
      this._bigWinContainer.visible = true;
      const self = this;
      this._introTimer = timerManager.addDelayedTimer(
        500,
        500,
        function (progress) {
          self._bigWinContainer.alpha = progress;
        },
        function () {
          self._mainPanel.visible = true;
          self._bigWinContainer.alpha = 1;
          if (self._screenObscuredCallback) {
            self._screenObscuredCallbackInvoked = true;
            self._screenObscuredCallback();
          }
        }
      );
    }

    outro() {
      const self = this;

      gameData.musicManager.endPotBonusCountUp();

      this._outroTimer = timerManager.addTimeout(2750, function () {
        self.showEndScreen();
        self.backToMainGame();
      });
    }

    showEndScreen() {
      if (
        !this._screenObscuredCallbackInvoked &&
        this._screenObscuredCallback !== undefined
      ) {
        this._screenObscuredCallback();
      }

      this._awardValue.setText(this.formatText(this._winAmount));

      const endY = this._awardValueEndPos.position.getY();
      this._bigWinAwardValueParent.position.setY(endY);

      this._awardValueShine.visible = true;
      this._awardValueShine.alpha = 0;
      this._awardValueShine.setText(this._awardValue.text);

      gsap
        .timeline()
        .to(this._awardValueShine, {
          duration: 0.2,
          alpha: 1,
        })
        .to(
          this._awardValueShine,
          {
            duration: 0.8,
            alpha: 0,
            onComplete: () => {
              this._awardValueShine.visible = false;
              this._awardValueShine.alpha = 0;
            },
          },
          "<+=0.4"
        );

      gsap.to(this._bigWinAwardValueParent, {
        duration: 1.2,
        pixi: { scaleX: 1.1, scaleY: 1.1 },
        ease: "elastic.out(3, 0.4)",
      });

      // turn off all stages - determine which stage we are in then reactivate it
      let activeStage = 0;
      for (let stage = 0; stage < this._thresholds.length; stage++) {
        this._stageContainers[stage].visible = false;

        const val = this._stake * this._thresholds[stage];
        if (this._winAmount >= val) {
          activeStage = stage;
        }
      }

      this._stageContainers[activeStage].visible = true;

      this._stageContainers[activeStage].scale.x = 1;
      this._stageContainers[activeStage].scale.y = 1;
      this._mainPanel.visible = true;

      this._animating = false;

      this._awardValue.setText(this.formatText(this._winAmount));
      timerManager.stop(this._outroTimer);
      timerManager.stop(this._countTimer);
      this._bigWinContainer.alpha = 1;
      this._bigWinContainer.visible = true;
      this._isBigWin = false;
    }

    backToMainGameFromSmallerWin() {
      this.stateMachine.switchState("IDLE");
    }

    backToMainGame() {
      const self = this;

      this._skipBigWinBox.visible = false;
      this._skipBigWinBox.interactive = false;

      this._awardGrowAnim = undefined;

      gsap.to(this._screenDim, {
        duration: 1,
        delay: this._endTimerDelayTime,
        alpha: 0,
        onComplete: () => {
          this._screenDim.visible = false;
          this._screenDim.alpha = 0;
        },
      });

      timerManager.addTimer(
        this._particleEmitEndTime,
        function (progress) {},
        function () {
          self._particles.particleEmitter.emit = false;
        }
      );

      gameData.musicManager.endBigWin();

      timerManager.addDelayedTimer(
        this._endTimerDelayTime,
        this._endTimerTime,
        function (progress) {
          self._bigWinContainer.alpha = 1 - progress;
          self._awardValue.alpha = 1 - progress;
          self._ray.alpha = 1 - progress;
        },
        function () {
          self._stageContainers.forEach(function (container) {
            container.alpha = 1;
            container.visible = false;
          });
          self._bigWinContainer.alpha = 1;
          self._bigWinContainer.visible = false;
          self._awardValue.alpha = 1;
          self._awardValue.visible = false;
          self._ray.visible = false;

          gameData.musicManager.setIdleMusic();

          resourceManager.getContainer(
            "bigWinBgContainerLandscape"
          ).visible = false;

          self._rayAnim.pause();

          self.stateMachine.switchState("IDLE");
          this._allowOrientationChange = false;
          self._callback();
        }
      );
    }

    skip() {
      if (this._animating) {
        if (this._isBigWin) {
          if (this._awardGrowAnim) {
            this._awardGrowAnim.kill();
          }

          gameData.musicManager.endPotBonusCountUp();
          this.showEndScreen();
          this.backToMainGame();
        }
      }
    }

    onSpin() {
      this._skippedBeforeTriggered = false;
    }

    clearSkippedFlag() {
      this._skippedBeforeTriggered = false;
    }
  }

  var bigWinCreator = function (json) {
    return new BigWin(json.numStages, json.thresholds, json.timePerStage);
  };

  var bigWinInitialiser = function (json, bigWin) {};

  var bigWinFilesRequired = function () {
    return [];
  };

  resourceManager.registerObjectType(
    "bigWin",
    bigWinCreator,
    bigWinInitialiser,
    bigWinFilesRequired
  );
})();
